var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTab1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5524 33.047C20.4134 32.7978 20.2581 32.5581 20.0875 32.3296C17.2555 29.2109 14.4278 26.0902 11.5703 22.9971C11.1691 22.5713 11.2667 22.3457 11.6149 21.9689C14.4172 18.9176 17.2039 15.8543 19.975 12.779C20.4144 12.2915 20.667 12.1659 21.1808 12.7407C23.9406 15.8295 26.7344 18.8864 29.5388 21.9327C29.9166 22.3435 29.9994 22.5713 29.5727 23.0396C26.7365 26.105 23.9342 29.2024 21.1256 32.2934C20.9643 32.4701 20.8326 32.6765 20.5524 33.047Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1864 21.6517C38.002 21.6517 35.0724 21.6517 32.1385 21.6517C31.9491 21.6605 31.7603 21.6243 31.5876 21.5458C31.4149 21.4674 31.2632 21.349 31.1449 21.2004C28.1262 17.8667 25.0961 14.5444 22.0546 11.2335C21.8439 11.0267 21.6783 10.7781 21.5687 10.5035C21.459 10.229 21.4076 9.9346 21.4178 9.63905C21.4581 6.52041 21.4368 3.40177 21.4368 0L41.1864 21.6517Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1824 23.3526L21.4392 45V41.2342C21.4392 39.214 21.4541 37.1896 21.4265 35.1715C21.4162 34.9456 21.4522 34.7199 21.5326 34.5086C21.6129 34.2973 21.7358 34.1048 21.8936 33.9432C25.0072 30.55 28.1088 27.1489 31.1983 23.74C31.3915 23.5272 31.5635 23.3441 31.8946 23.3462C34.9219 23.3569 37.9471 23.3526 41.1824 23.3526Z",
    fill: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00292969 21.6524L19.7461 0.00927734C19.7461 3.56857 19.7461 6.88306 19.7461 10.1975C19.7461 10.5743 19.5338 10.7808 19.3215 11.0107C16.2079 14.4423 13.0887 17.8732 9.96372 21.3033C9.86318 21.4224 9.73642 21.5165 9.5935 21.5782C9.45058 21.6399 9.29535 21.6674 9.14 21.6588C6.17215 21.6482 3.20642 21.6524 0.00292969 21.6524Z",
    fill: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7432 44.9942L0 23.3511C3.23321 23.3511 6.25837 23.3511 9.28141 23.3511C9.61259 23.3511 9.78667 23.5278 9.97986 23.7406C13.0779 27.1467 16.1767 30.5527 19.2761 33.9587C19.5394 34.2461 19.7538 34.5186 19.7517 34.9699C19.7347 38.2077 19.7432 41.4626 19.7432 44.9942Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab1);
export default __webpack_public_path__ + "static/media/tab1.579e9ffbf32fa594cbc59a3f90f228b8.svg";
export { ForwardRef as ReactComponent };